import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Watchlist panel art: four starred rows, each a ticker pill, a name bar and a
 * sparkline, alternating rising and falling.
 */

/** A 5-point star, outer radius 6 / inner radius 2.6, centred on the origin. */
const STAR_POINTS =
  '0,-6 1.53,-2.1 5.71,-1.85 2.47,0.8 3.53,4.85 0,2.6 -3.53,4.85 -2.47,0.8 -5.71,-1.85 -1.53,-2.1'

/** [row centre y, name bar width, sparkline path, rising?] */
const ROWS: [number, number, string, boolean][] = [
  [22, 40, 'M106 26 L116 22 L126 24 L136 19 L148 17', true],
  [42, 32, 'M106 38 L116 42 L126 40 L136 45 L148 47', false],
  [62, 44, 'M106 66 L116 62 L126 64 L136 59 L148 57', true],
  [82, 36, 'M106 78 L116 82 L126 80 L136 85 L148 87', false],
]

export function WatchlistArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {ROWS.map(([cy, barWidth, spark, rising]) => (
        <g key={cy}>
          <polygon
            points={STAR_POINTS}
            transform={`translate(16 ${cy})`}
            fill="hsl(var(--primary))"
          />
          <rect
            x={28}
            y={cy - 4}
            width={20}
            height={8}
            rx={3}
            fill="hsl(var(--foreground) / 0.22)"
          />
          <rect
            x={54}
            y={cy - 2}
            width={barWidth}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
          <path
            d={spark}
            fill="none"
            stroke={rising ? 'hsl(var(--chart-candle-up))' : 'hsl(var(--chart-candle-down))'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      ))}
    </svg>
  )
}
